import axios from "../axiosInstance";

class WeekService {
  async getWeekNumber(date) {
    return await axios.get(`week/weekIndex`, { params: { date } });
  }
}

export default new WeekService();
